import { render, staticRenderFns } from "./formpage.vue?vue&type=template&id=2af40f66&scoped=true&"
import script from "./formpage.vue?vue&type=script&lang=js&"
export * from "./formpage.vue?vue&type=script&lang=js&"
import style0 from "./formpage.vue?vue&type=style&index=0&id=2af40f66&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2af40f66",
  null
  
)

export default component.exports